import { render, staticRenderFns } from "./DashboardLaundry.vue?vue&type=template&id=220dc23b&scoped=true"
import script from "./DashboardLaundry.vue?vue&type=script&lang=js"
export * from "./DashboardLaundry.vue?vue&type=script&lang=js"
import style0 from "./DashboardLaundry.vue?vue&type=style&index=0&id=220dc23b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220dc23b",
  null
  
)

export default component.exports